export const GEO_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'group',
  'organizational_unit',
  'public_agent_module_permission',
  'group_module_permission',
  'bond_option',
  'citizen',
  'public_agent',
  'module',
  'bond',
]
